<div class="events-background">
  <div class="background-color padding-10 d-flex flex-column ">
    <div class="d-flex">
      <div class="d-flex flex-wrap gap-3 event-tabs">
        <div class="events-type" [ngClass]="(currentSelectedEventsType && (currentSelectedEventsType === 'All')) ? 'selected-event-type' : ''" (click)="selectEventType('All')">All</div>
        <div class="events-type" [ngClass]="(currentSelectedEventsType && (currentSelectedEventsType === 'Growth Plan')) ? 'selected-event-type' : ''" (click)="selectEventType('Growth Plan')">Growth Plan</div>
      </div>
      <div class="create-event d-flex justify-content-end" *ngIf="currentSelectedEventsType === 'All' && (org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq')">
        <span class="pointer plan-button float-right" (click)="addNewEvent()"><i class="ion-plus-round pe-1"></i> Create Event</span>
      </div>

    </div>
    <div class="mt-3 d-flex flex-column" style="background-color: #FCFCFD;border: 1px solid #D0D5DD; border-radius: 3px;padding: 10px;height: calc(100vh - 180px)">

      <ng-template [ngIf]="currentSelectedEventsType === 'All'">
        <div class="d-flex flex-column mt-3" *ngIf="upcomingEvents && upcomingEvents.length > 0">
          <div class="d-flex justify-content-between">
            <div class="bold" style="font-size: 16px;">Upcoming Events</div>
            <div>
              <button class="navigate-icon-left" (click)="previous()" [disabled]="startIndex === 0">
                <i class="icon ion-chevron-left"></i>
              </button>
              <button  class="navigate-icon-right" (click)="next()"[disabled]="endIndex >= upcomingEvents.length">
                <i class="icon ion-chevron-right"></i>
              </button>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-start gap-2 mt-2">
            <div class="upcoming-event-box d-flex flex-column" *ngFor="let event of visibleEvents"
                 [ngStyle]="{'background-color': event.bgColor}">
              <div class="d-flex justify-content-between">
                <div class="mt-1 mb-1 bold" style="font-size: 16px">{{event.startDate}}</div>
                <ng-template [ngIf]="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
                  <button mat-icon-button [matMenuTriggerFor]="beforeMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #beforeMenu="matMenu"  xPosition="before">
                    <button mat-menu-item class="vendor-options" (click)="openEventForEdit(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/edit.png"/>Edit</button>
                    <button mat-menu-item class="vendor-options" (click)="showEventInfo(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/eye.png"/>View</button>
                    <button mat-menu-item class="vendor-options" (click)="deleteEvent(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/trash.png"/>Delete</button>
                  </mat-menu>
                </ng-template>
              </div>
              <div class="pointer" (click)="showEventInfo(event)">
                <div class="mt-2 mb-1 bold event-name">{{event.name}}</div>
                <div class="mt-1 mb-2 event-description" style="font-size: 13px;">
                  <div [innerHTML]="event.description"></div>
                </div>
                <div class="d-flex justify-content-between location-time">
                  <div *ngIf="event.location"><img class="growth-plan-icon" src="../../../../images/growth-plan/map-pin.png"/> {{event.location}}</div>
                  <div *ngIf="event.timeValue"><img class="growth-plan-icon" src="../../../../images/growth-plan/clock.png"/> {{event.timeValue}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column mt-3" [ngStyle]="{'height': (upcomingEvents && upcomingEvents.length > 0) ? 'calc(50vh - 60px)' : 'calc(80vh - 60px)'}">
          <div class="d-flex flex-column gap-3 flex-fill min-h-0 overflow-auto" style="padding-right: 8px;">
            <div class="d-flex plan-box"  *ngFor="let event of normalEvents">
              <div class="growth-event-logo" style="width: 10rem" [ngStyle]="event.logoBg"></div>
              <div class="d-flex justify-content-between w-100">
                <div class="d-flex flex-column ps-3 pe-3" style="width: 80%">
                  <div class="name mb-2 pointer event-name"  (click)="showEventInfo(event)">{{event.name}}</div>
                  <div class="d-flex justify-content-between text">
                    <div class="d-flex" *ngIf="event.date">
                      <div><img class="growth-plan-icon" src="../../../../images/growth-plan/calendar.png"/></div>
                      <div>{{event.date}}</div>
                    </div>
                    <div class="d-flex" *ngIf="event.timeValue">
                      <div><img class="growth-plan-icon" src="../../../../images/growth-plan/clock.png"/></div>
                      <div>{{event.timeValue}}</div>
                    </div>
                    <div class="d-flex" *ngIf="event.location">
                      <div><img class="growth-plan-icon" src="../../../../images/growth-plan/map-pin.png"/></div>
                      <div>{{event.location}}</div>
                    </div>
                  </div>
                </div>
                <div>
                <span class="pointer float-right" *ngIf="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
                  <button mat-icon-button [matMenuTriggerFor]="beforeMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #beforeMenu="matMenu"  xPosition="before">
                    <button mat-menu-item class="vendor-options" (click)="openEventForEdit(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/edit.png"/>Edit</button>
                    <button mat-menu-item class="vendor-options" (click)="showEventInfo(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/eye.png"/>View</button>
                    <button mat-menu-item class="vendor-options" (click)="deleteEvent(event)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/trash.png"/>Delete</button>
                  </mat-menu>
                </span>
                  <span *ngIf="event.link" class="text register-link float-right pointer" (click)="eventRegisterLink(event)">Register Here <img class="growth-plan-icon ps-1" src="../../../../images/core-focus/external-link.png"/></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="currentSelectedEventsType === 'Growth Plan'">
        <div class="events-container" *ngIf="growthEvents && growthEvents.length == 0">
          <div class="d-flex align-items-center justify-content-center" style="height: 20vh;">
            No events available.
          </div>
        </div>

        <div class="d-flex flex-column flex-fill min-h-0 overflow-auto" *ngIf="growthEvents && growthEvents.length > 0">
           <div class="d-flex align-items-center justify-content-center" *ngIf="!(currentPlan && currentPlan.toLowerCase().includes('growth'))">
            <div  class="w-100 text-start d-block ">
              Please Contact
              <a href="mailto:support&#64;taxplaniq.com" rel="noopener noreferrer" target="_blank">
              support&#64;taxplaniq.com
            </a>
              to upgrade to Growth Plan to access the content below.
            </div>
          </div>
          <div class="d-flex flex-column mb-3 pointer" *ngFor="let event of growthEvents">
            <div class="d-flex flex-column mt-2 plan-box">
              <div class="d-flex padding-10">
                <div class="event-logo" style="width: 10rem" [ngStyle]="event.logoBg"></div>
                <div class="d-flex flex-column ps-3 pe-3 w-100">
                  <div class="name mb-2">
                    <span class="pointer" (click)="handleEventClick(event)">{{event.name}}</span>
                  </div>
                  <div class="text event-description">
                    <div [innerHTML]="event.description"></div>
                  </div>
                </div>
              </div>
              <div class="d-flex event-details text gap-4 mt-1">
                <div *ngIf="event.date"><img class="growth-plan-icon" src="../../../../images/growth-plan/calendar.png"/>{{event.date}}</div>
                <div *ngIf="event.timeValue"><img class="growth-plan-icon" src="../../../../images/growth-plan/clock.png"/>{{event.timeValue}}</div>
                <div *ngIf="event.location"><img class="growth-plan-icon" src="../../../../images/growth-plan/map-pin.png"/>{{event.location}}</div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div *ngIf="reveal['createOrEditEvent']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['createOrEditEvent']}">
  </div>
  <div class="reveal tax-strategy-reveal new-tpiq-reveal" style="padding: 0; border: none;" [ngClass]="{'tpiq-reveal': reveal['createOrEditEvent']}">
    <div class="reveal-header">
      <span class="float-left">{{(editMode) ? 'Edit Event' : 'Create Event'}}</span>
      <span class="float-right pointer" (click)="hideReveal('createOrEditEvent')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish new-input-fields d-flex flex-column flex-fill min-h-0 overflow-auto" style="padding: 15px;height: calc(100vh - 60px)">
      <div class="d-flex flex-column">
        <div>
          <label>Title*
            <input type="text" placeholder="Enter title here..." [(ngModel)]="event.name"/>
          </label>
        </div>
        <div class="mb-3">
          <label>Description*
            <div class="padding-10" style="border:1px solid #cacaca;border-radius: 3px;" [froalaEditor]="editorOptions" [(froalaModel)]="event.description"></div>
          </label>
        </div>
        <div class="d-flex mt-2 mb-2">
          <div class="d-flex flex-column" style="width: 30%;">
            <div>
              <label>Recurring</label>
            </div>
            <div>
              <input type="checkbox" [(ngModel)]="event.recurring" [checked]="event.recurring" />
            </div>
          </div>
          <div class="d-flex flex-column w-100">
            <div>
              <label>Frequency</label>
            </div>
            <div>
              <label>
                <ng-template [ngIf]="event.recurring">
                  <app-tpiq-select-dropdown [setData]="frequencyTypes" [includeNone]="false" (onValueSelect)="setFrequency($event)"
                                         [setDefaultValue]="event.frequency || 'Weekly'" [setSearchKey]="'name'" [setPlaceHolder]="'Frequency'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
                </ng-template>
                <ng-template [ngIf]="!event.recurring">
                  <input type="text" placeholder="Frequency" disabled/>
                </ng-template>
              </label>
            </div>
          </div>
        </div>
        <ng-template [ngIf]="event.recurring">
          <div class="d-flex gap-3 mt-3">
            <div class="w-100">
              <label>Start Date*
                <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'ddd, MMM DD YYYY'" [mindate]="minDate" [(ngModel)]="event.startDate"
                       (valueChanged)="setEventDate($event, 'start')"  placeholder="Date(ddd, MMM DD YYYY)"/>
              </label>
            </div>
            <div class="w-100">
              <label>End Date*
                <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'ddd, MMM DD YYYY'" [mindate]="minDate" [(ngModel)]="event.endDate"
                       (valueChanged)="setEventDate($event, 'end')"  placeholder="Date(ddd, MMM DD YYYY)"/>
              </label>
            </div>
          </div>
          <div class="d-flex gap-3">
            <div class="w-100">
              <label for="eventTime">Time*
                <input type="time" id="eventTime" name="eventTime" placeholder="Time" [(ngModel)]="event.timeRange"/>
              </label>
            </div>
          </div>
        </ng-template>

        <div class="d-flex gap-3 mt-3" *ngIf="!event.recurring">
          <div class="w-100">
            <label>Date*
              <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'ddd, MMM DD YYYY'" [mindate]="minDate" [(ngModel)]="event.date"
                     (valueChanged)="setEventDate($event)"  placeholder="Date(ddd, MMM DD YYYY)"/>
            </label>
          </div>
          <div class="w-100">
            <label for="eventTime">Time*
              <input type="time" id="eventTime" name="eventTime" placeholder="Time" [(ngModel)]="event.timeRange"/>
            </label>
          </div>
        </div>
        <div>
          <label>Location
            <input type="text" placeholder="Location" [(ngModel)]="event.location"/>
          </label>
        </div>
        <div>
          <label>Link
            <input type="text" placeholder="Link" [(ngModel)]="event.link"/>
          </label>
        </div>
        <div>
          <section class="upload-area create-post" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)" (fileOver)="fileOverBase($event)">
            <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
              <div class="columns medium-12 text-center">
                <span class="pointer">
                  <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                  <label for="eventThumbnailUpload" class="button upload-section-content">Upload logo for event thumbnail.</label>
                </span>
                <input type="file" accept=".pdf,image/*" id="eventThumbnailUpload" (change)="fileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader"/>
              </div>
            </div>
          </section>
        </div>
        <div class="mt-3" *ngIf="logoFiles.length > 0">
          <div class="d-flex flex-wrap">
            <div class="d-flex uploaded-file-box mb-2 flex-column" *ngFor="let logo of logoFiles; let index = index;">
              <ng-template [ngIf]="logo.name">
                <div class="d-flex justify-content-between file-name-box">
                  <div class="file-name">{{logo.name}}</div>
                  <div class="pointer" (click)="deleteDocumentFile(logo, index)">
                    <i class="icon ion-android-close"></i>
                  </div>
                </div>
                <div class="mt-2" style="padding: 0px;margin-left: 0px" *ngIf="logo.link">
                  <img class="image-zoom" [src]="logo.link"/>
                </div>
              </ng-template>
            </div>
          </div>

        </div>
      </div>
      <div class="mt-4">
        <button class="button small float-right" (click)="createOrEditEvent()">{{(editMode) ? 'Update' : 'Create'}}</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['showEvent']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['showEvent']}">
  </div>
  <div class="reveal tax-strategy-reveal new-tpiq-reveal" style="padding: 0; border: none;" [ngClass]="{'tpiq-reveal': reveal['showEvent']}">
    <div class="reveal-header">
      <span class="float-right pointer" (click)="hideReveal('showEvent')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish new-input-fields d-flex flex-column" style="padding: 15px;height: calc(100vh - 60px)">
      <div class="d-flex flex-column show-event flex-fill min-h-0 overflow-auto">
        <div class="d-flex flex-column growth-title-border">
          <div class="title ps-3">{{selectedEvent.name}}</div>
        </div>
        <div class="d-flex mt-3 event-date-sec">
          <div><img src="../../../../images/growth-plan/timer-dec.png"/></div>
          <div class="d-flex flex-column ps-3">
            <div class="event-date">{{selectedEvent.date}}</div>
            <div class="mt-1">Online, private for TaxPlanIQ paid users.</div>
            <div class="d-flex mt-3" *ngIf="currentSelectedEventsType === 'All'"><span class="text register-link float-right pointer" (click)="eventRegisterLink(selectedEvent)">Register Here <img class="growth-plan-icon ps-1" src="../../../../images/core-focus/external-link.png"/></span></div>
            <div class="d-flex mt-3" *ngIf="currentSelectedEventsType === 'Growth Plan'">
              <button class="button small" disabled>Register Here</button>
            </div>
          </div>
        </div>
        <div class="mt-2" style="color: #475467">
          <app-tpiq-froala-view [data]="selectedEvent.description"></app-tpiq-froala-view>
        </div>
      </div>
    </div>
  </div>
</div>
